import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import autobind from 'core-decorators/lib/autobind';

import { getRequestedWidgetSize, getIsInitialWidgetSizeWasSet } from 'shared/selectors/app-settings';

import { updateAppSettings } from 'widget/redux/client/actions/app-settings';


// If iFrame was hidden during loading, window.innerWidth can be = 0
// need to wait for setting real window.innerWidth

@connect(state => ({
  appSettings: state.appSettings,
  requestedWidgetSize: getRequestedWidgetSize(state),
  isInitialWidgetSizeWasSet: getIsInitialWidgetSizeWasSet(state),
}), {
  updateAppSettings,
})
export default class SetInitialWidgetSize extends React.Component {

  static propTypes = {
    appSettings: PropTypes.object,
    requestedWidgetSize: PropTypes.object,
    updateAppSettings: PropTypes.func,
    isInitialWidgetSizeWasSet: PropTypes.bool,
  };

  static defaultProps = {
    disabled: false,
  };

  componentDidMount() {
    if (this.props.isInitialWidgetSizeWasSet) {
      return;
    }
    this.updateWidgetSizeInterval = setInterval(this.updateWidgetSize, 200);
  }

  componentWillUnmount() {
    clearInterval(this.updateWidgetSizeInterval);
  }

  @autobind
  updateWidgetSize() {
    const { appSettings } = this.props;

    const widgetSize = {
      width: window.innerWidth,
      height: window.innerHeight,
    };

    if (!widgetSize.width || _.isEmpty(appSettings)) {
      return;
    }

    clearInterval(this.updateWidgetSizeInterval);
    const { requestedWidgetSize, updateAppSettings } = this.props;
    if (_.isEqual(requestedWidgetSize, widgetSize)) {
      return;
    }

    updateAppSettings({
      requestedWidgetSize: widgetSize,
    });
  }

  render() {
    return null;
  }
}



// WEBPACK FOOTER //
// ./src/widget/data-components/set-initial-widget-size.js